import ErrorWithStatus from './ErrorWithStatus'

export default class UnauthorizedError extends ErrorWithStatus {
}
